import { gql } from 'graphql-tag'

const profitCenterFragment = gql`
  fragment profitCenterFragment on ProfitCenter {
    id
    name
    type
    id
    efficiencyFactors {
      month
      efficiencyFactor
    }
  }
`
const stationFragment = gql`
  fragment stationFragment on Station {
    id
    name
  }
`

const budgetPlanFragment = gql`
  fragment budgetPlanFragment on BudgetPlan {
    id
    date
    station {
      ...stationFragment
    }
    profitCenter {
      ...profitCenterFragment
    }
    dailyData {
      id
      date
      budgetedSales
      budgetedHours
      actualHours
      actualSales
      budgetedEfficiency
    }
    salesIndex
    hoursIndex
  }
  ${profitCenterFragment}
  ${stationFragment}
`

const plannedDataFragment = gql`
  fragment plannedDataFragment on MonthlySalesPlan {
    stationId
    monthDate
    dailyData {
      date
      plannedHours
      plannedSales
      actualSales
      actualHours
      plannedEfficiency
      actualEfficiency
      note {
        id
        date
        note
      }
    }
  }
`

export const fetchProfitCenters = gql`
  query fetchProfitCenters($stationId: ID!) {
    station(id: $stationId) {
      id
      profitCenters {
        ...profitCenterFragment
      }
    }
  }
  ${profitCenterFragment}
`

export const fetchBudgetAndPlan = gql`
  query fetchBudgetAndPlan($stationId: ID!, $profitCenterId: Int, $thisMonth: String!, $lastMonth: String!) {
    budgetThisMonth: budgetPlan(stationId: $stationId, profitCenterId: $profitCenterId, date: $thisMonth) {
      ...budgetPlanFragment
    }
    planThisMonth: monthlySalesPlan(stationId: $stationId, monthDate: $thisMonth, profitCenterId: $profitCenterId) {
      ...plannedDataFragment
    }
    planLastMonth: monthlySalesPlan(stationId: $stationId, monthDate: $lastMonth, profitCenterId: $profitCenterId) {
      ...plannedDataFragment
    }
    budgetLastMonth: budgetPlan(stationId: $stationId, profitCenterId: $profitCenterId, date: $lastMonth) {
      ...budgetPlanFragment
    }
  }
  ${budgetPlanFragment}
  ${plannedDataFragment}
`

export const fetchBudgetAndForecastAndPlan = gql`
  query fetchBudgetAndForecastAndPlan($stationId: ID!, $profitCenterId: Int, $thisMonth: String!, $lastMonth: String!) {
    budgetThisMonth: budgetPlan(stationId: $stationId, profitCenterId: $profitCenterId, date: $thisMonth) {
      ...budgetPlanFragment
    }
    forecastThisMonth: monthlyForecastSales(stationId: $stationId, monthDate: $thisMonth) {
      station {
        id
        name
      }
      monthDate
      dailyData {
        date
        sales
      }
    }
    planThisMonth: monthlySalesPlan(stationId: $stationId, monthDate: $thisMonth, profitCenterId: $profitCenterId) {
      ...plannedDataFragment
    }
    planLastMonth: monthlySalesPlan(stationId: $stationId, monthDate: $lastMonth, profitCenterId: $profitCenterId) {
      ...plannedDataFragment
    }
    budgetLastMonth: budgetPlan(stationId: $stationId, profitCenterId: $profitCenterId, date: $lastMonth) {
      ...budgetPlanFragment
    }
  }
  ${budgetPlanFragment}
  ${plannedDataFragment}
`

export const upsertMonthlySalesPlan = gql`
  mutation UpsertMonthlySalesPlan($monthlySalesPlan: MonthlySalesPlanInput!) {
    upsertMonthlySalesPlan(monthlySalesPlan: $monthlySalesPlan) {
      stationId
      monthDate
      dailyData {
        date
        plannedHours
        plannedSales
      }
    }
  }
`

export const upsertMonthlySalesPlanNote = gql`
  mutation UpsertMonthlySalesPlanNote($noteInput: MonthlySalesPlanNoteInputType!) {
    upsertMonthlySalesPlanNote(noteInput: $noteInput) {
      id
      date
      station {
        ...stationFragment
      }
      note
    }
  }
  ${stationFragment}
`
